export function buildHistoryPanelRestoreSnapshot(
  navId,
  {
    page = 1,
    pageSize = 20,
    filters = {},
    filterInputs = {},
    highlightTaskId = '',
  } = {},
) {
  return {
    navId,
    page,
    pageSize,
    filters: { ...filters },
    filterInputs: { ...filterInputs },
    highlightTaskId: highlightTaskId ? String(highlightTaskId) : '',
  };
}

export function mergeDetailNavigateState(existingState = {}, fromHistory) {
  if (!fromHistory) return existingState;
  return { ...existingState, fromHistory };
}
